export default __webpack_public_path__ + "9dbe8a64367305c7809adb440c0fce6c.svg";